import { StaffTimeTrackingPage } from "@/components/staff-time-tracking/StaffTimeTrackingPage";

export default function StaffTimeTrackingPageRoute() {
  return <StaffTimeTrackingPage />;
}

